// extracted by mini-css-extract-plugin
export var animationContainer = "_ip-0";
export var asteriskIcon = "_ip-8";
export var conversationLeftSection = "_ip-4";
export var conversationListItem = "_ip-3";
export var conversationMiddleSection = "_ip-5";
export var conversationRightSection = "_ip-6";
export var detailsContent = "_ip-1";
export var listContainer = "_ip-7";
export var modalContent = "_ip-2";